import * as React from "react";

import HelpIcon from "@mui/icons-material/Help";
import { default as MUIButton } from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";

import { LaunchDialog } from "src/domain/core/workflow";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  textAlign: "center",
  backgroundColor: "#FFF",
  display: "flex",
  justifyContent: "space-between",
}));

const Button = styled(MUIButton)(() => ({
  minWidth: "75px",
  maxHeight: "30px",

  a: {
    textDecoration: "none",
  },
}));

const StackName = styled("div")(({ theme }) => ({
  ...theme.typography.body2,
  display: "flex",
  alignItems: "center",
}));

interface WorkflowProps {
  id: number;
  name: string;
  description: string;
  disabled: boolean;
  nodes: Nodes;
  blueprints: WorkflowBlueprintDesc[];
  disks: Disk[];
  disksError: Error;
  templates: Template[];
}

export const Workflow: React.FC<WorkflowProps> = ({
  id,
  name,
  description,
  disabled,
  nodes,
  blueprints,
  disks,
  disksError,
  templates,
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <Item elevation={3} data-testid={name}>
        <StackName>
          <span>{name}</span>
          <Tooltip title={description}>
            <IconButton size="small">
              <HelpIcon
                data-testid={name + "-helpicon"}
                sx={{
                  fontSize: "1.25rem",
                }}
              />
            </IconButton>
          </Tooltip>
        </StackName>
        <Button
          size="small"
          variant="contained"
          data-testid={name + "-launch"}
          disabled={disabled}
          onClick={() => {
            setModalOpen(true);
          }}
        >
          Launch
        </Button>
      </Item>
      <LaunchDialog
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        blueprintId={id}
        nodes={nodes}
        blueprints={blueprints}
        disks={disks}
        disksError={disksError}
        source="launch-workflow"
        templates={templates}
        template={null}
      />
    </>
  );
};
